export enum Role {
  MANAGE_CONTACT = "MANAGE_CONTACT",
  CONTACT_VIEW = "CONTACT_VIEW",
  MANAGE_TEMPLATE = "MANAGE_TEMPLATE",
  MANAGE_AGENT = "MANAGE_AGENT",
  MANAGE_AGENT_GROUP = "MANAGE_AGENT_GROUP",
  TEAM_INBOX = "TEAM_INBOX",
  CONVERSATION_VIEW = "CONVERSATION_VIEW",
  BROADCAST = "BROADCAST",
  BROADCAST_VIEW = "BROADCAST_VIEW",
  BROADCAST_HISTORY = "BROADCAST_HISTORY",
  BROADCAST_ADD = "BROADCAST_ADD",
  BROADCAST_SCHEDULE = "BROADCAST_SCHEDULE",
  AUTOMATION = "AUTOMATION",
  AUTOMATION_DEF_ACTIONS = "AUTOMATION_DEF_ACTIONS",
  ORDERS = "ORDERS",
  ORDERS_VIEW = "ORDERS_VIEW",
  PARCELS = "PARCELS",
  MANAGE_DELIVERYMAN = "MANAGE_DELIVERYMAN",
  MERCHANT = "MERCHANT",
  ANALYTICS_CHAT = "ANALYTICS_CHAT",
  REFERENTIAL_MANAGE = "REFERENTIAL_MANAGE",
  AUDIT_MANAGE = "AUDIT_MANAGE",
  REFERENTIAL_VAR_MANAGE = "REFERENTIAL_VAR_MANAGE",
  COMPANY_MANAGE = "COMPANY_MANAGE",
  CATALOG_SUBSCRIPTION = "CATALOG_SUBSCRIPTION",
  ACTION_ON_TEMPLATE = "ACTION_ON_TEMPLATE",
  CONSULT_NOTIFS = "CONSULT_NOTIFS",
  ADMIN_SOLUTION = "ADMIN_SOLUTION",
  DASHY_COMPANIES = "DASHY_COMPANIES",
  MANAGE_BOTS = "MANAGE_BOTS",
  AUTH_TEMPLATE_MANAGE = "AUTH_TEMPLATE_MANAGE",
  ADMIN_CONVERSATIONS = "ADMIN_CONVERSATIONS",
  ADMIN_SOLUTION_UI = "ADMIN_SOLUTION_UI",
  MANAGE_FLOW = "MANAGE_FLOW",
  PRODUCT = "PRODUCT",
  PRODUCT_VIEW = "PRODUCT_VIEW",
  REFERENTIAL_DEVISE_MANAGE = "REFERENTIAL_DEVISE_MANAGE",
  MANAGE_TICKET = "MANAGE_TICKET",
  TICKET_VIEW = "TICKET_VIEW",
  MANAGE_ATTRIBUTE = "MANAGE_ATTRIBUTE",
  MANAGE_TICKET_ASSIGNMENT = "MANAGE_TICKET_ASSIGNMENT",
  MANAGE_VOUCHER = "MANAGE_VOUCHER",
  VOUCHER_VIEW = "VOUCHER_VIEW",
  /** Read-only access to templates, bots, AI agents, flows and automations. */
  WORKFLOW_VIEW = "WORKFLOW_VIEW",
  MANAGE_PAYMENT_LINK = "MANAGE_PAYMENT_LINK",
  PAYMENT_VIEW = "PAYMENT_VIEW",
  PAYMENT_SIM_ACCESS = "PAYMENT_SIM_ACCESS",
  MANAGE_AIASSISTANT = "MANAGE_AIASSISTANT",
  MANAGE_PAYMENT_AUTHZ = "MANAGE_PAYMENT_AUTHZ",
  MANAGE_SAVED_CARDS = "MANAGE_SAVED_CARDS",
  MANAGE_PAYMENT_SCHEDULES = "MANAGE_PAYMENT_SCHEDULES",
  RESERVATION_HOSTELS = "RESERVATION_HOSTELS",
  MANAGE_SUBSCRIPTION = "MANAGE_SUBSCRIPTION",
  MANAGE_PAYMENT_ONBOARDING = "PAYMENT_ONBOARDING_ADMIN",
  PAYMENT_ONBOARDING_VIEW = "PAYMENT_ONBOARDING_VIEW",
  /**
   * "Delivery by DashyPay" (managed courier). Granted per client organisation by Dashy in Keycloak only;
   * deliberately absent from the merchant permission catalog so a client admin cannot self-grant it.
   */
  DELIVERY_BY_DASHYPAY = "DELIVERY_BY_DASHYPAY",
}
